import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: Icon;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  children?: ReactNode;
}

export function EmptyState({ icon: IconComponent, title, description, actionLabel, onAction, className, children }: EmptyStateProps) {
  return (
    <div role="status" className={cn('flex flex-col items-center justify-center py-14 px-4 text-center', className)}>
      <IconComponent size={40} weight="light" aria-hidden className="mb-3 text-[var(--naia-text-secondary)]" />
      <p className="m-0 font-semibold text-[14px] text-[var(--naia-text-primary)]">{title}</p>
      {description && <p className="m-0 mt-1 text-[13px] text-[var(--naia-text-secondary)] max-w-[360px]">{description}</p>}
      {actionLabel && onAction && (
        <Button onClick={onAction} className="mt-4 min-h-11">{actionLabel}</Button>
      )}
      {children}
    </div>
  );
}
